<template>
  <div class="curtain"></div>
</template>

<script>
import axios from '@/helpers/axios'
import { mapState } from 'vuex'

export default {
  name: 'RefToken',
  props: ['timeout'],
  methods: {
    refresh () {
      let appid = this.appid
      let appkey = this.appkey

      axios
        .get(`/accesstoken?app_id=${appid}&app_key=${appkey}`)
        .then((response) => {
          if (response.data.token) {
            localStorage.setItem('t_tk', response.data.token)
            localStorage.setItem(
              'xrd',
              new Date(response.data.expired_time).getTime()
            )
          }
          window.location.reload()
        })
        .catch((error) => {
          this.errnotif = error.response.data.message
        })
    },
    clear () {
      // localStorage.clear()
      localStorage.removeItem('_pid')
      localStorage.removeItem('_pky')
      localStorage.removeItem('_idc')
      localStorage.removeItem('_ict')
      localStorage.removeItem('t_tk')
      localStorage.removeItem('u_nm')
      localStorage.removeItem('e_rcv')
      localStorage.removeItem('lg_cl')
      localStorage.removeItem('xrd')
      window.location.reload()
    }
  },
  computed: {
    ...mapState(['appid', 'appkey', 'expired'])
  },
  created () {
    let expired = this.expired
    if (this.timeout && new Date().getTime() - expired < 4 * 60 * 60 * 1000) {
      this.refresh()
    } else {
      this.clear()
    }
  }
}
</script>

<style scoped>
.curtain {
  position: fixed;
  width: 115%;
  height: 115%;
  background: #69696980;
  margin: -15%;
  z-index: 100;
}
</style>
